import { Navigate } from "react-router";
import { useMe } from "@/hooks/use-me";
import { useActiveOrg } from "@/hooks/use-active-org";
import { LoadingSpinner } from "../ui/loading-spinner";

export function BillingRedirect() {
  const { isLoading } = useMe();
  const { orgId } = useActiveOrg();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <LoadingSpinner />
      </div>
    );
  }

  if (!orgId) {
    return <Navigate to="/workspaces" replace />;
  }

  return <Navigate to={`/org/${orgId}/settings/billing`} replace />;
}
